<template>
  <b-list-group class="condensed">
    <!-- {{params.currency}} -->
    <b-list-group-item class="py-2">
      <span class="detail-summary-tag">Total rezervari:</span><span class="detail-summary-info text-dark"> <b>{{summary.total}}</b> </span>
    </b-list-group-item>
    <b-list-group-item class="py-2">
      <span class="detail-summary-tag">Total pasageri:</span><span class="detail-summary-info text-info"><b>{{summary.pax}}</b> </span>
    </b-list-group-item>
    <b-list-group-item class="py-2">
      <span class="detail-summary-tag">Total plata:</span><span class="detail-summary-info text-primary"> <b>{{round(summary.price - summary.commission) }} {{currency}}</b></span>
    </b-list-group-item>
    <b-list-group-item class="py-2">
      <span class="detail-summary-tag">Total platit:</span><span class="detail-summary-info text-success"> <b>{{round(summary.paid)}} {{currency}}</b> </span>
    </b-list-group-item>
    <b-list-group-item class="py-2">
      <span class="detail-summary-tag">Rest plata:</span><span class="detail-summary-info text-danger"> <b>{{round(summary.price - summary.commission - summary.paid) }} {{currency}}</b> </span>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import { round } from '@/shared/utils'

export default {
  name: 'bookingSummary',
  props: ['results', 'params'],
  data () {
    return {
      currency: '',
      round: round
    }
  },
  created () {
    // this.currency = this.results[0].currency
    this.results.map(el => {
      this.currency = el.currency
    })
  },
  computed: {
    summary () {
      const summary = {
        total: this.results.length,
        pax: 0,
        price: 0,
        commission: 0,
        paid: 0
      }

      this.results.map(booking => {
        summary.pax += booking.pax
        summary.price += booking.gross + booking.tax
        summary.commission += booking.commission
        summary.paid += booking.paid_amount
      })

      const ret = {
        total: round(summary.total),
        pax: summary.pax,
        price: round(summary.price),
        commission: round(summary.commission),
        paid: round(summary.paid)
      }

      return ret
    }
  }
}
</script>

<style>

.detail-summary-tag {
  display: inline-block;
  width: 45%;
  font-weight: 700;
  color: #000;
}
.detail-summary-info{
  display: inline-block;
  width: 45%;
}
</style>
